import { Controller, useFormContext } from 'react-hook-form'

import {
  PickerFormControl,
  PickerFormControlMemberIdProps,
} from '../EntityPicker/PickerFormControl.js'

import { FormFieldProps } from './typings.js'

export function FormMemberIdPicker({
  name,
  validation,
  /**
   * Will override default Form onChange behavior. The original onChange will be passed as the second argument
   */
  onChange: overrideOnChange,
  ...rest
}: Omit<
  FormFieldProps<PickerFormControlMemberIdProps>,
  'value' | 'onChange'
> & {
  onChange?: (
    memberIds: string[],
    originalOnChange?: (memberIds: string[]) => void,
  ) => void
}) {
  const { control } = useFormContext()

  return (
    <Controller
      control={control}
      name={name}
      rules={validation}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <PickerFormControl.MemberIdPicker
          {...rest}
          name={name}
          invalid={!!error?.message}
          error={error?.message}
          value={value}
          onChange={value => {
            if (overrideOnChange) {
              overrideOnChange(value, onChange)
            } else {
              onChange(value)
            }
          }}
        />
      )}
    />
  )
}
